var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlasp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73666 72.9829C-1.17604 68.0757 -1.17605 60.1197 3.73658 55.2125L44.259 14.7354L64.026 34.4803L14.6085 83.8425L3.73666 72.9829Z",
    fill: "#FF4E74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6763 64.0977L44.2592 14.7354L55.131 3.87568C60.0437 -1.03147 68.0087 -1.03148 72.9213 3.87568L113.444 44.3528L93.6763 64.0977Z",
    fill: "#FFF85E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0262 93.7148L113.444 44.3528L124.315 55.2125C129.228 60.1197 129.228 68.0757 124.315 72.9829L83.7929 113.46L64.0262 93.7148Z",
    fill: "#76FF54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9212 124.32C68.0086 129.227 60.0436 129.227 55.1309 124.32L14.6085 83.8424L34.3755 64.0977L83.7928 113.46L72.9212 124.32Z",
    fill: "#5C94FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasp);
export default __webpack_public_path__ + "static/media/glasp.415ffc1ce54dbdbbb1fb9f728b08dc71.svg";
export { ForwardRef as ReactComponent };